import * as tslib_1 from "tslib";
import { ErrorHandler } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../../auth/auth/auth.service';
import { environment } from '../../../environments/environment';
import { BusinessTag } from '../../business/models/business-tag.model';
var TagService = /** @class */ (function () {
    function TagService(_http, _auth, _errorHandler) {
        this._http = _http;
        this._auth = _auth;
        this._errorHandler = _errorHandler;
    }
    /**
     * function makes get call to server api. gets all tags.
     * @return {Promise<BusinessTag[]>}
     */
    TagService.prototype.getAllTags = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var URL, RESPONSE, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        URL = environment.airportsApiUrl + "/tags";
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._http.get(URL).toPromise()];
                    case 2:
                        RESPONSE = _a.sent();
                        if (!RESPONSE) {
                            this._errorHandler.handleError(new Error('API did not return valid tag object'));
                        }
                        else {
                            return [2 /*return*/, (RESPONSE || []).map(function (d) { return BusinessTag.parse(d); })];
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        this._errorHandler.handleError(e_1);
                        throw e_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @param {number} tagID id of tag to add;
     * @param {number} businessID of business to add tag to;
     * function makes post call to api server. adds tag to business.
     * @return {Promise<BusinessTag[]>}
     */
    TagService.prototype.postTag = function (tagID, businessID) {
        var URL = environment.airportsApiUrl + "/business/" + businessID + "/tag";
        try {
            var BODY = { tagID: tagID };
            return this._http.post(URL, BODY).toPromise();
        }
        catch (e) {
            this._errorHandler.handleError(e);
            throw e;
        }
    };
    /**
     * @param {number} tagID id of tag to add;
     * @param {number} airportID of airport to add tag to;
     * function makes post call to api server.
     * @return {Promise<any>}
     */
    TagService.prototype.postAirportTag = function (tagID, airportID) {
        var URL = environment.airportsApiUrl + "/airports/" + airportID + "/tag";
        try {
            var BODY = { tagID: tagID };
            return this._http.post(URL, BODY).toPromise();
        }
        catch (e) {
            this._errorHandler.handleError(e);
            throw e;
        }
    };
    /**
     * updates tag in api server.
     * @param {number} tagID
     * @param {number} businessID
     * @return {Promise<any>}
     */
    TagService.prototype.putTag = function (tagID, businessID) {
        var URL = environment.airportsApiUrl + "/business/" + businessID + "/tag/" + tagID;
        try {
            return this._http.put(URL, '').toPromise();
        }
        catch (e) {
            this._errorHandler.handleError(e);
            throw e;
        }
    };
    /**
     *
     * @param {number} tagID id of tag to delete;
     * @param {number} businessID of business to delete tag from;
     * function makes delete call to api server. deletes tag from api server.
     * @return {Promise<BusinessTag[]>}
     */
    TagService.prototype.deleteTag = function (tagID, businessID) {
        var URL = environment.airportsApiUrl + "/business/" + businessID + "/tag/" + tagID;
        try {
            return this._http.delete(URL).toPromise();
        }
        catch (e) {
            this._errorHandler.handleError(e);
            throw e;
        }
    };
    /**
     *
     * @param {number} tagID id of tag to delete;
     * @param {number} airportID of airport to delete tag from;
     * function makes delete call to api server. deletes tag from api server.
     * @return {Promise<any>}
     */
    TagService.prototype.deleteAirportTag = function (tagID, airportID) {
        var URL = environment.airportsApiUrl + "/airports/" + airportID + "/tag/" + tagID;
        try {
            return this._http.delete(URL).toPromise();
        }
        catch (e) {
            this._errorHandler.handleError(e);
            throw e;
        }
    };
    /**
     * returns tag of given name
     * @param {Tag[]} tags
     * @param {string} name
     * @return {Tag}
     */
    TagService.prototype.findTagByName = function (tags, name) {
        return tags.find(function (tag) { return tag.tagName === name; });
    };
    /**
     *
     * @param {Tag[]} tags
     * @param {number} id
     * @return {Tag}
     */
    TagService.prototype.findTagById = function (tags, id) {
        return tags.find(function (tag) { return tag.tagId === id; });
    };
    /**
     * Seraches the given input list of tags for any that have the search value in the name and returns them
     * @param {Tag[]} tags
     * @param {string} name
     * @return {Tag[]}
     */
    TagService.prototype.searchTagsByName = function (tags, searchValue) {
        return tags.filter(function (tag) { return tag.tagName.includes(searchValue); });
    };
    return TagService;
}());
export { TagService };
